export default {
  Json: 'JSON',
  Xml: 'XML',
}
